module.exports = __webpack_public_path__ + "img/02.a7dc7cb0.jpg";